import $ from 'jquery';
setTimeout(function () {
  var $externalLinks = $('[data-external-link]');
  var $modal = $('#external-link');
  var $modalContinue = $modal.find('.button--continue');
  var href = '';
  $externalLinks.on('click', onClickExternalLink);

  ////

  function onClickExternalLink(event) {
    var $link = $(this);
    href = $link.attr('href');
    event.preventDefault();
    event.stopPropagation();
    $modalContinue.attr('href', href);
    $modal.addClass('active');
  }
}, 1000);